import API from '@/api'

export default {
  namespaced: true,
  state: {
    data: [],
    loaded: false,
  },
  mutations: {
    saveData(state, data) {
      state.data = data;
    },
    load(state) {
      state.loaded = true;
    }
  },
  actions: {
    updateData(context, payload) {
      return API.misc.getCountries().then(res => {
        const items = [];

        for (const key in res.data.data) {
          items.push({
            key: key,
            label: res.data.data[key],
            value: res.data.data[key]
          });

        }
        context.commit('saveData', items);
        context.commit('load');
      });
    }
  },
  getters: {
    data(state) {
      return state.data;
    },
    isLoaded(state) {
      return state.loaded;
    },
  }
}
